import { render, staticRenderFns } from "./PlayBikkurapon.vue?vue&type=template&id=4b5390d0&scoped=true&"
import script from "./PlayBikkurapon.vue?vue&type=script&lang=js&"
export * from "./PlayBikkurapon.vue?vue&type=script&lang=js&"
import style0 from "./PlayBikkurapon.vue?vue&type=style&index=0&id=4b5390d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5390d0",
  null
  
)

export default component.exports